import { DealerModel } from './dealer'
// 登录用户

export enum Role {
  ADMIN = 'ADMIN',
  DEALER = 'DEALER',
  ROOT = 'ROOT',
}

export const UsersOrderBy: {
  [key: string]: string;
} = {
  phone: 'PHONE',
  email: 'EMAIL',
  username: 'USERNAME',
  createdAt: 'CREATED_AT',
  updatedAt: 'UPDATED_AT'
}

export interface User{
  createdAt?: string;
  dealer?: DealerModel;
  email?: string;
  id: number;
  jwt?: string;
  phone: string;
  role: Role;
  updatedAt?: string;
  username: string;
}
